/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class ServiceDtoModel extends JSONable {
  uuid: string | undefined = undefined;
  version: number | undefined = undefined;
  serviceTypeValue: string | undefined = undefined;
  trafficChannelTypeValue: string | undefined = undefined;
  volumeUnitValue: string | undefined = undefined;
  weightUnitValue: string | undefined = undefined;
  shipmentType: string | undefined = undefined;
  incotermValue: string | undefined = undefined;
  origin: string | undefined = undefined;
  destination: string | undefined = undefined;
  destinationAddresses: Array<any> | undefined = undefined;
  originAddresses: Array<any> | undefined = undefined;
  weightPerShipment: number | undefined = undefined;
  volumePerShipment: number | undefined = undefined;
  revenuePerShipment: number | undefined = undefined;
  grossProfitPerShipment: number | undefined = undefined;
  shipmentsPerYear: number | undefined = undefined;
  transitTime: number | undefined = undefined;
  comments: string | undefined = undefined;
  tags: Array<string> | undefined = undefined;
  currencyCode: string | undefined = undefined;
}
